import ProductModel from '../../../models/stripe/Product';
import HttpReference from '../../platform/HttpReference';
import Products from './Products';

export default class Product extends HttpReference<ProductModel, void, Products> {}
